import PropTypes from "prop-types";
import React, { Fragment } from "react";
import CustomSelect from "../custom-components/select";
import CRFlag from "../../../../static/images/flag-CR.svg";
import PAFlag from "../../../../static/images/flag-PA.svg";
import ErrorIcon from "../../../../static/images/error-icon.svg";
import { useTranslation } from "react-i18next";

var items = [
  {
    id: `CR`,
    name: (
      <Fragment>
        <img src={CRFlag} /> Costa Rica
      </Fragment>
    ),
    value: `CR`,
  },
  {
    id: `PA`,
    name: (
      <Fragment>
        <img src={PAFlag} /> Panamá
      </Fragment>
    ),
    value: `PA`,
  },
];
const ClientCountries = (props) => {
  const { t } = useTranslation();

  const displayError = () => {
    return props.error != undefined && props.error != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{props.error}</div>
      </div>
    ) : null;
  }

  var placeholder = props.placeholder !== undefined ? props.placeholder : t("landing.subtitle");

  return (
    <div>
      <CustomSelect
        id={props.id}
        items={items}
        className={props.className}
        handleChange={props.onChange}
        readOnly={props.readOnly}
        placeholder={placeholder}
        valueAttr={`id`}
        value={props.value}
      />
      {displayError()}
    </div>
  );
};

ClientCountries.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
};

export default ClientCountries;
